import { Maybe } from '../generated/graphql'
import { pipe } from 'fp-ts/es6/function'
import * as O from 'fp-ts/es6/Option'

export const convertNullableToUndefined = <T>(input: Maybe<T>): T | undefined =>
  pipe(
    input,
    O.fromNullable,
    O.getOrElse<T | undefined>(() => undefined),
  )
